export default __webpack_public_path__ + "static/media/start.db84ae2a.svg";